import React from 'react';

import fetch from '../fetch';

import moment from 'moment';

import utils from '../../utils';

import {Modal, message} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const headers = utils.columns([
    {type: 'selection'},
    {key:'$index', label: '序号'},

    {key:'orgName', label: '部门名称', width: 150},
    {key:'totalEmployeeNum', label: '应参评人数'},
    {key:'evalEmployeeNum', label: '实参评人数'},
    {key:'unEvalEmployeeNum', label: '未参评人数'},
    {key:'evalPercent', label: '参评比例'},
    {key:'优Num', label: '优(人数)'},
    {key:'优Percent', label: '优(比例)'},
    {key:'良Num', label: '良(人数)'},
    {key:'良Percent', label: '良(比例)'},
    {key:'中Num', label: '中(人数)'},
    {key:'中Percent', label: '中(比例)'},
    {key:'差', label: '差(人数)'},
    {key:'差Percent', label: '差(比例)'},
]);


/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };

    return fetch.post('eval/termOrg/listTotalByTerm', Object.assign(defaultsParams, keywords))
    .then(response => {
        const columns = [
            {type: 'selection'},
            {key:'$index', label: '序号', width: 75},

            {key:'orgName', label: '部门名称', width: 150},
            {key:'totalEmployeeNum', label: '应参评人数', width: 120},
            {key:'evalEmployeeNum', label: '实参评人数', width: 120},
            {key:'unEvalEmployeeNum', label: '未参评人数', width: 120},
            {key:'evalPercent', label: '参评比例', width: 120},
        ];

        response.payload.meta.extParams.thHeader.forEach((index) => {
            columns.push({key: index +'Num', label: index+'(人数)', width: 100});
            columns.push({key: index +'Percent', label: index+ '(比例)', width: 100});
        });

        return {
            dataList: (response.payload.data.dataList || []).map(function(item) {
                return Object.assign({}, item, item.evalResult);
            }),
            headers: utils.columns(columns),
            pageNum: response.payload.data.pageNum,
            total: response.payload.data.total,
            pageSize: response.payload.data.pageSize
        }
    })
    .then(data => (Object.assign({
        headers: data.headers,
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

/**
 * 生成部门汇总数据
 */
const createAllData = (keywords = {}) => {
    return fetch.post('eval/termOrg/listTotalByTerm/generate', keywords)
    .then((response) => {
        if(response.code === 200) {
            message.success(response.message);
        }
        
    });
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}


/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'mulEval/listTotalByOrgTerm'+ url;
};

const getSelection =() => {
    return DataGrid.selections;
}

export default {
    querySearch,
    headers,
    onSelect,
    setRefresh,
    redirect,
    createAllData,
    getSelection
}